import th from 'vuetify/src/locale/th.ts'

export default {
  ...th
}
